import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  ORDER_KEY, ORDER_TYPE, SEARCH, SORT,
} from 'constants/formFields';
import { ORDERS } from 'constants/interfaces';
import { initiateVCFormSchema } from 'utils/validators';

import type { TInitiateVCFormSchema } from 'utils/validators';

const useInitiateVCForm = () => {
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
  } = useForm<TInitiateVCFormSchema>({
    mode: 'onChange',
    resolver: yupResolver(initiateVCFormSchema),
    defaultValues: {
      [SEARCH]: '',
      [SORT]: {
        [ORDER_KEY]: '',
        [ORDER_TYPE]: ORDERS.asc,
      },
    },
  });

  return {
    control,
    handleSubmit,
    getValues,
    setValue,
  };
};

export default useInitiateVCForm;
